export default __webpack_public_path__ + "static/media/s1fs4p61.b7b5f76e.jpg";